export const MENU_SPACE_KEY = "SpaceId";
export const defaultSpaceId = 1;
